import React, { Component } from 'react';

class UserInfo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="user-details__info">
                    {/* {TODO Add here content} */}
                </div>
            </React.Fragment>
        )
    }
}

export default UserInfo;